<div class="pharmacy-pill" data-cy="pharmacy">
  <span class="pharmacy-pill__ncpdp-and-name"> {{ pharmacy?.ncpdp }} - {{ pharmacy?.name }} </span>
  <img class="pharmacy-pill__delete" (click)="emitDelete()" src="assets/icons/close.png" data-cy="pharmacyDelete" />
</div>
